import { PARAM_DELIMITER, PreparedSortCriteria, SortCriteria, SortDirection } from '@steelbuy/api-integration';

export const createSortString = <Model>(sort: SortCriteria<Model> | PreparedSortCriteria) =>
    sort
        .map(
            (sortCriteria) =>
                `${sortCriteria.property.toString()}:${sortCriteria?.direction ?? SortDirection.ASCENDING}`
        )
        .join(PARAM_DELIMITER);
